import {
    BabelPropertyDescriptor,
    createPropertyOrMethodDecorator,
} from "../FormContext/DecoratorsContext/DecoratorsCompatibility";
import { getCandyHub } from "../../../Forms/Sentry/InitializeSentry";

export function executionTimeMonitor<CP extends unknown[]>(
    operation: string,
    executionLimitTime: number
): MethodDecorator & PropertyDecorator {
    return createPropertyOrMethodDecorator(function decorator(
        _,
        __,
        descriptor: BabelPropertyDescriptor<unknown, unknown>
    ): BabelPropertyDescriptor<unknown, unknown> {
        if ("value" in descriptor) {
            const originalMethod = descriptor.value;

            descriptor.value = async function value(...args: CP) {
                if (performance != undefined && "now" in performance) {
                    const startTime = performance.now();

                    // @ts-ignore
                    const result = await originalMethod.apply(this, args);

                    const endTime = performance.now();
                    const timespan = endTime - startTime;
                    if (timespan > executionLimitTime) {
                        getCandyHub().captureException(
                            new Error(`Execution duration is too long: ${operation} ${timespan}ms`)
                        );
                    }

                    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
                    return result;
                }

                // @ts-ignore
                // eslint-disable-next-line @typescript-eslint/no-unsafe-return
                return originalMethod.apply(this, args);
            };
        }

        return descriptor;
    });
}
